import { DEBUG } from "../../enviroment";
import { significantType } from "./number";

import 'leaflet.markercluster';
import 'leaflet.markercluster/dist/MarkerCluster.css';
import 'leaflet.markercluster/dist/MarkerCluster.Default.css';

export * from "./number";

declare global {
    interface Number {
        toSignificantDigits(significantDigits: significantType): string;
    }
    interface Window {
        clarity: any;
    }
}

declare module 'leaflet' {
    export interface MarkerClusterOptions {
        maxClusterRadius?: ((zoom: number) => number) | number;

        iconCreateFunction?: (cluster: MarkerClusterGroup) => DivIcon;

        clusterPane?: string;

        spiderfyOnEveryZoom?: boolean;
        spiderfyOnMaxZoom?: boolean;
        showCoverageOnHover?: boolean;
        zoomToBoundsOnClick?: boolean;

        singleMarkerMode?: boolean;
        disableClusteringAtZoom?: number;
        removeOutsideVisibleBounds?: boolean;

        animate?: boolean;
        animateAddingMarkers?: boolean;

        spiderfyShapePositions?: (length: number, center: LatLng) => Point[];
        spiderfyDistanceMultiplier?: number;
        spiderLegPolylineOptions?: PolylineOptions;

        chunkedLoading?: boolean;
        chunkInterval?: number;
        chunkDelay?: number;
        chunkProgress?: (processed: number, total: number, elapsedTime: number) => void;

        polygonOptions?: PolylineOptions;
    }
    export function markerClusterGroup(options?: MarkerClusterOptions): MarkerClusterGroup;
    export class MarkerClusterGroup extends FeatureGroup {
        addLayer(layer: Layer): this;
        removeLayer(layer: Layer): this;
        clearLayers(): this;
        getChildCount(): number;
    }
}


export const startPrototypes = () => {
    // Não retirar esta função daqui, pois é necessário inicializar este arquivo
    if (DEBUG){
        //
    }
};